import { MARQUEE_ITEMS } from "@/lib/data";

export const Marquee = () => {
  const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className="relative overflow-hidden border-y border-amber-500/15 bg-[#0B1D14] py-5" data-testid="editorial-marquee">
      <div className="animate-marquee flex w-max items-center gap-10">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10">
                <span className="font-display text-lg italic tracking-wide text-amber-200/80 sm:text-xl">{item}</span>
                <span className="h-1.5 w-1.5 rounded-full bg-amber-500/70 animate-filament" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
